import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getPersonIdFromToken } from '@ibk/shared-auth';
import { selectAccessToken, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { Loading } from '@ibk/shared-ui';
export function SettingsGuard({ children }) {
    const accessToken = useAppSelector(selectAccessToken);
    const personId = accessToken ? (getPersonIdFromToken(accessToken) ?? undefined) : undefined;
    const { isFeatureFlagWhiteListed, isLoading } = useFeatureFlag(personId);
    if (isLoading) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (!personId || !isFeatureFlagWhiteListed(FeatureFlagUseCase.ERP_SETTINGS)) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
